import { DefaultTheme } from 'styled-components';

export const FORM_HEIGHT = '60px';

const FormTheme = (theme: DefaultTheme) => {
  return {
    selectBox: {
      control: {
        height: FORM_HEIGHT,
        borderRadius: '0px',
        borderWidth: '0px',
        backgroundColor: theme.white,
        cursor: 'pointer',
        transition: `box-shadow 300ms linear`,
      },
      placeholder: {
        color: theme.backgroundMid,
        fontFamily: 'Open Sans',
        fontWeight: 300,
      },
      menu: {
        marginTop: '0px',
        paddingTop: '0px',
        borderRadius: '0px',
        backgroundColor: theme.backgroundLightest,
        zIndex: 999,
      },
      menuList: {
        paddingTop: '0px',
        paddingBottom: '0px',
        '::-webkit-scrollbar': {
          width: '4px',
          height: '0px',
        },
        '::-webkit-scrollbar-track': {
          background: theme.lightGrey,
          borderRadius: '10px',
        },
        '::-webkit-scrollbar-thumb': {
          background: theme.backgroundLight,
          borderRadius: '10px',
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: theme.backgroundLight,
        },
      },
      option: {
        defaultColour: theme.darkGrey,
        defaultBackgroundColor: theme.lightGrey,
        selectedColor: theme.white,
        hoverColor: theme.darkGrey,
        hoverBackgroundColor: theme.backgroundLightest,
        selectedBackgroundColor: theme.primary,
        padding: '11px 15px',
        lineHeight: 'initial',
      },
      valueContainer: {
        height: FORM_HEIGHT,
        lineHeight: 'initial',
      },
      group: {
        backgroundColor: theme.lightGrey,
      },
      groupHeading: {
        color: theme.primary,
        fontSize: '13px',
        fontWeight: 'bold',
        marginBottom: '0.5em',
      },
      multiValue: {
        backgroundColor: theme.primary,
      },
      multiValueLabel: {
        color: theme.white,
        fontSize: '14px',
        padding: '6px',
      },
      multiValueRemove: {
        color: theme.white,
        cursor: 'pointer',
        ':hover': {
          backgroundColor: theme.buttonHover,
          color: theme.darkGrey,
        },
      },
    },
  };
};

export default FormTheme;
